export default __webpack_public_path__ + "static/media/about_us_new_map.3322e4e7.jpeg";